<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <template v-for="dept in items" :key="dept.id">
    <!-- 父节点 -->
    <tr class="tree-row parent hover:bg-slate-50">
      <td class="px-4 py-3">
        <div class="flex items-center gap-1" :style="{ paddingLeft: level * 24 + 'px' }">
          <button
            v-if="dept.children && dept.children.length > 0"
            class="tree-toggle w-4 h-4 text-slate-400 cursor-pointer flex-shrink-0"
            :class="{ expanded: expandedIds.includes(dept.id) }"
            @click="$emit('toggle', dept.id)"
          >
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
            </svg>
          </button>
          <span v-else class="w-4 h-4 flex-shrink-0"></span>
          <svg class="w-4 h-4 text-blue-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd"/>
          </svg>
          <span class="text-sm font-medium text-slate-900">{{ dept.name }}</span>
        </div>
      </td>
      <td class="px-4 py-3 text-sm text-slate-600">{{ dept.code || '-' }}</td>
      <td class="px-4 py-3 text-sm text-slate-900">{{ dept.sort }}</td>
      <td class="px-4 py-3 text-sm text-slate-600">{{ dept.manager || '-' }}</td>
      <td class="px-4 py-3">
        <span v-if="dept.status" class="status-badge bg-green-100 text-green-800">
          <span class="w-1.5 h-1.5 bg-green-500 rounded-full mr-1"></span>正常
        </span>
        <span v-else class="status-badge bg-red-100 text-red-800">
          <span class="w-1.5 h-1.5 bg-red-500 rounded-full mr-1"></span>停用
        </span>
      </td>
      <td class="px-4 py-3">
        <div class="flex items-center gap-1">
          <button v-permission="'org:dept:add'" class="table-action-button is-primary" title="新增" aria-label="新增" @click="$emit('add', dept)">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
            </svg>
          </button>
          <button v-permission="'org:dept:edit'" class="table-action-button is-primary" title="修改" aria-label="修改" @click="$emit('edit', dept)">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
            </svg>
          </button>
          <button v-permission="'org:dept:remove'" class="table-action-button is-danger" title="删除" aria-label="删除" @click="$emit('delete', dept)">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
            </svg>
          </button>
        </div>
      </td>
    </tr>
    <!-- 子节点递归渲染 -->
    <template v-if="dept.children && dept.children.length > 0 && expandedIds.includes(dept.id)">
      <DeptTreeItem
        v-for="child in dept.children"
        :key="child.id"
        :items="[child]"
        :level="level + 1"
        :expanded-ids="expandedIds"
        @toggle="onToggle"
        @add="(d) => $emit('add', d)"
        @edit="(d) => $emit('edit', d)"
        @delete="(d) => $emit('delete', d)"
      />
    </template>
  </template>
</template>

<script setup>
defineOptions({
  name: 'DeptTreeItem'
})

const emit = defineEmits(['toggle', 'add', 'edit', 'delete'])

function onToggle(deptId) {
  emit('toggle', deptId)
}

defineProps({
  items: {
    type: Array,
    required: true
  },
  level: {
    type: Number,
    default: 0
  },
  expandedIds: {
    type: Array,
    default: () => []
  }
})
</script>

<style scoped>
.tree-toggle {
  transition: transform 0.2s;
}
.tree-toggle.expanded {
  transform: rotate(90deg);
}
</style>
